import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useCompare() {
  return {
    compare: GlobalPrototypes.compare,
  }
}
